import React, { useEffect, useRef } from 'react';
import { Period, PERIODS } from '../../utils/const';
import { dictionary } from '../../utils/dictionary';
import { useAuth } from '../../context/AuthContext';

interface PeriodSelectProps {
  selected: Period;
  onSelect: (period: Period) => void;
  onClose: () => void;
}

const PeriodSelect: React.FC<PeriodSelectProps> = ({ selected, onSelect, onClose }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { language } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="absolute right-0 mt-2 w-48 bg-white rounded-[20px] shadow-sm border border-gray-200 py-2 z-10"
    >
      {PERIODS.map((period) => (
        <button
          key={period.key}
          className={`
            w-full px-4 py-2 text-left text-sm transition-colors
            ${selected === period.key ? 'text-purple-600 bg-purple-50' : 'text-gray-700 hover:bg-gray-50'}
          `}
          onClick={() => onSelect(period.key)}
        >
          {dictionary[period.key][language]}
        </button>
      ))}
    </div>
  );
}

export default PeriodSelect;